import { Toast } from "antd-mobile";
import axios from "axios";
import React, { useContext, useEffect, useState } from "react";
import { Card, Col, Form, Row } from "react-bootstrap";
import { useNavigate } from "react-router-dom";

import PsContext from "../../context";
import { APP_TYPE, DB_POSTFIX, formToObject } from "../../utils";
import { ServiceUrl } from "../../utils/serviceUrl";
import Header from "../header";
import { Button, TextField } from "@mui/material";

const StudentRegister = (props) => {
  const context = useContext(PsContext);
  const navigate = useNavigate();

  const [loader, setLoader] = useState(false);
  const [validated, setValidated] = useState(false);

  useEffect(() => {
    if (context.getStorage("update_stu_profile") == "yes") {
      navigate("/stu/update-profile");
    }
  }, []);

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() == false) {
      e.stopPropagation();
      setValidated(true);
      return;
    }
    if (APP_TYPE != "SASS") {
      checkLogin(form);
      return;
    }
    context.setLoader(true);
    let fx = formToObject(form);
    const f = new FormData();
    f.append("username", fx.registerno + "@" + DB_POSTFIX);
    axios.post(ServiceUrl.LOGIN_V2.CHECK, f).then((res) => {
      if (res["data"].status == "1") {
        axios.defaults.headers.common["Api-Token"] = `${res["data"].api}`;
        //setRedirect(res["data"].data);
        checkLogin(form);
      } else {
        Toast.show({
          content: res["data"].message || "Error",
          position: "top",
        });
        context.setLoader(false);
      }
    });
  };

  const checkLogin = (form) => {
    context.setLoader(true);
    axios
      .post(ServiceUrl.STUDENTS.CHECK_REGISTER_NO_EXIST, form)
      .then((res) => {
        if (res["data"].status == "1") {
          let d = res["data"].data;
          //let q = "uuid="
          navigate("/stu/verify-mobile", { state: d });
        } else {
          Toast.show({ content: res["data"].message || "Error" });
        }
        context.setLoader(false);
      });
  };

  return (
    <>
      <Header
        title="Update Profile"
        backAction={[]}
        rightActions={[]}
        onBack={(e) => navigate("/stu/login")}
      />

      <div className="">
        <div className="container-sm py-md-3" data-aos="zoom-in">
          <Form
            action=""
            method="post"
            noValidate
            validated={validated}
            onSubmit={handleFormSubmit}
          >
            <Card>
              <Card.Header className="card-header-bg">Search</Card.Header>
              <Card.Body>
                <Row className="mt-3">
                  <Col md={12}>
                    <TextField
                      required
                      id="outlined-required"
                      name="registerno"
                      fullWidth
                      autoFocus={true}
                      label="Admission No / Register No / Application No"
                    />
                    {/*<label>
                  Register No <span className="text-danger">*</span>
                </label>
                <Form.Control
                  type="text"
                  name="registerno"
                  required
                  placeholder="Register No / Application No"
                />*/}
                  </Col>
                </Row>

                <Row className="mt-4">
                  <Col md={12}>
                    <Button type="submit" variant="contained" fullWidth>
                      Go Next
                    </Button>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Form>
        </div>
      </div>
    </>
  );
};
export default StudentRegister;
